module.exports = __webpack_public_path__ + "static/media/error404.87a14ad7.svg";